<template>
    <v-btn
        v-if="showIt"
        :small="isSmall"
        icon
        :color="color"
        @click="$emit('click')"
    >
    <v-icon :small="isSmall">{{icon}}</v-icon>
    </v-btn>
</template>

<script>
import supertops from '~api/supertops';
import DOWNLOAD_REPORT_USERS from '~api/download_report_access';

export default {
  name: 'SendEmailFileButton',
  props: {
    additionalAcceptableAccounts: {
      type: Array,
      default: () => [],
    },
    color: {
      type: String,
      default: 'grey darken-2',
    },
    icon: {
      type: String,
      default: 'mdi-email-newsletter',
    },
    isSmall: {
      type: Boolean,
      default: true,
    },
    nowCoping: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      forSupertops: true,
    };
  },
  computed: {
    showIt() {
      if (this.forSupertops && supertops.includes(this.account.id)) {
        return true;
      }

      if (DOWNLOAD_REPORT_USERS.includes(this.account.phone)) {
        return true;
      }

      if (this.additionalAcceptableAccounts.length > 0 && this.additionalAcceptableAccounts.includes(this.account.id)) {
        return true;
      }

      return false;
    },
    account() {
      return this.$store.getters['account/account'];
    },
  },

};
</script>

<style scoped>

</style>
